import React from 'react'
import { Spinner } from './spinner'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

export enum ButtonStyle {
  PRIMARY,
  RED,
  GREY,
}
export type ButtonAdminProps = {
  onClick?: (e) => void
  disabled?: boolean
  loading?: boolean
  className?: string
  text: string
  style?: ButtonStyle
  icon?: React.ReactNode
  type?: 'button' | 'submit' | 'reset'
}

const ButtonAdminComponent: React.FC<ButtonAdminProps> = ({
  onClick,
  disabled = false,
  loading = false,
  className,
  text,
  style = ButtonStyle.PRIMARY,
  icon,
  type = 'button',
}) => {
  return (
    <button
      className={twMerge(
        'flex h-10 items-center space-x-2 rounded-md bg-admin-blue px-4 leading-none text-white',
        style == ButtonStyle.PRIMARY && 'bg-admin-blue',
        style == ButtonStyle.RED && 'bg-red-600',
        style == ButtonStyle.GREY &&
          'border border-[#00000020] bg-admin-grey-300 text-black',
        disabled && 'opacity-50',
        className
      )}
      onClick={onClick}
      disabled={loading || disabled}
      type={type}>
      {!loading && (
        <>
          {icon}
          <span>{text}</span>
        </>
      )}
      {loading && (
        <div className="flex h-full w-full items-center justify-center">
          <Spinner color="white" />
        </div>
      )}
    </button>
  )
}

export default ButtonAdminComponent
